import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { LoadingState } from './ui/loading';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
  requiredPermission?: string;
}

export function ProtectedRoute({ children, requiredRole, requiredPermission }: ProtectedRouteProps) {
  const { isAuthenticated, loading, user, hasRole, canAccess } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingState>Checking authentication...</LoadingState>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredRole && !hasRole(requiredRole)) {
    return (
      <div className="flex items-center justify-center min-h-96">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900">Access Denied</h2>
          <p className="text-gray-600 mt-2">You don't have permission to access this page.</p>
          <p className="text-sm text-gray-500 mt-1">Required role: {requiredRole}</p>
        </div>
      </div>
    );
  }

  if (requiredPermission && !canAccess(requiredPermission)) {
    return (
      <div className="flex items-center justify-center min-h-96">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900">Access Denied</h2>
          <p className="text-gray-600 mt-2">You don't have permission to access this page.</p>
          <p className="text-sm text-gray-500 mt-1">Your role: {user?.role}</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}